import {createReducer} from '@reduxjs/toolkit';
import {saveIpRangesFailure} from 'src/openapi/admin/apis/IpControllerApi';
import {generateNewKeyFailure} from 'src/openapi/admin/apis/KeyControllerApi';
import {
    crmIntegrationFailure,
    crmIntegrationRequest,
    enabledFailure,
    enabledRequest,
    fullAccessFailure,
    fullAccessRequest,
    getSettingsSuccess,
} from 'src/openapi/admin/apis/SettingsControllerApi';

import {clearData, clearError} from '../actions';

import type {Error} from 'src/openapi/admin/models/Error';
import type {Settings} from 'src/openapi/admin/models/Settings';

export type SettingsById = {
    [accountId: number]: Settings,
};

export type State = {
    data: SettingsById,
    error: Error | null,
    setupBusy: boolean,
};

const defaultState: State = {
    data: {},
    error: null,
    setupBusy: false,
};


export const setupData = createReducer(defaultState, builder => builder
    .addCase(crmIntegrationRequest, state => {
        state.setupBusy = true;
    })
    .addCase(fullAccessRequest, state => {
        state.setupBusy = true;
    })
    .addCase(enabledRequest, state => {
        state.setupBusy = true;
    })
    .addCase(getSettingsSuccess, (state, action) => {
        state.setupBusy = false;
        state.data = {
            ...state.data,
            [action.payload.meta.accountId]: action.payload.data,
        };
    })
    .addCase(enabledFailure, (state, action) => {
        state.error = action.payload.data;
        state.setupBusy = false;
    })
    .addCase(fullAccessFailure, (state, action) => {
        state.error = action.payload.data;
        state.setupBusy = false;
    })
    .addCase(generateNewKeyFailure, (state, action) => {
        state.error = action.payload.data;
        state.setupBusy = false;
    })
    .addCase(saveIpRangesFailure, (state, action) => {
        state.error = action.payload.data;
        state.setupBusy = false;
    })
    .addCase(crmIntegrationFailure, (state, action) => {
        state.error = action.payload.data;
        state.setupBusy = false;
    })
    .addCase(clearError, state => {
        state.error = null;
    })
    .addCase(clearData, state => {
        state.data = {};
        state.error = null;
        state.setupBusy = false;
    }),
);
